/*
 * The Chart Room — sticky buy bar, phones only.
 *
 * NOTE FOR WHOEVER READS THIS NEXT. README.md lists "no sticky add-to-cart
 * bars" under "Things that are deliberate, not oversights". This file is a
 * deliberate reversal of that line for the mobile product page only, made in
 * the conversion pass; the README entry has been rewritten to say so rather
 * than left to contradict the code. If the reversal is not wanted, delete this
 * file, assets/cr-sticky-buy.css rules in chart-room.css, the section, and put
 * the README line back — nothing else depends on it.
 *
 * The restraint that keeps it inside the brand: it carries the product name,
 * the price and one button. No countdown, no stock number, no "X people are
 * viewing", no animation beyond a fade, and it is not shown at all until the
 * real buy button has been scrolled past.
 *
 * HOW IT SUBMITS
 * The bar's button is not a copy of the buy button and does not post to the
 * cart itself. It calls form.requestSubmit() on the page's real product form,
 * which dispatches a real submit event — so whatever handles that form handles
 * the bar identically, with no second code path to keep in step.
 *
 * That matters twice over. On the landing template the form is the one from
 * snippets/cr-buy-form.liquid, and assets/cr-buy-now.js listens for its submit
 * event, so the bar gets the same one-tap route to checkout as the button
 * above it. On any page still using Dawn's buy buttons, <product-form> handles
 * it exactly as it handles a tap on the real button, and the existing-client
 * gate in gated-addon.js (a capture-phase listener on document) still runs
 * first and can still block it. Anything that bypassed the form would bypass
 * the gate.
 *
 * Both forms are rendered with novalidate, so requestSubmit() does not run
 * constraint validation — which is the same behaviour as the real button.
 */
(function () {
  if (window.__crStickyBuyBound) return;
  window.__crStickyBuyBound = true;

  var MOBILE = '(max-width: 749px)';

  function init() {
    var bar = document.querySelector('[data-cr-sticky-buy]');
    if (!bar) return;

    // The landing template's own form first, Dawn's second. Whichever is on
    // the page, the bar drives the real control rather than a copy of it.
    var form =
      document.querySelector('[data-cr-buy] form[action*="/cart/add"]') ||
      document.querySelector('product-form form[action*="/cart/add"]');
    var realButton =
      document.querySelector('[data-cr-buy] [data-cr-buy-now]') ||
      document.querySelector('product-form .product-form__submit');
    if (!form || !realButton) return;

    var barButton = bar.querySelector('[data-cr-sticky-buy-button]');

    // A disabled or sold-out product gets no bar at all. A bar whose button
    // cannot do anything is worse than no bar.
    if (realButton.hasAttribute('disabled')) return;

    if (barButton) {
      barButton.addEventListener('click', function () {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          // Safari < 16. Clicking the real button routes through the same
          // submit event, and scrolling to it first means a blocked submit
          // (the gate) still shows its message somewhere the visitor can see.
          realButton.scrollIntoView({ block: 'center' });
          realButton.click();
        }
      });
    }

    // The bar is shown only once the real button has left the viewport, and is
    // hidden again the moment it comes back — so the two are never on screen
    // together asking for the same tap.
    var visible = false;
    function show(next) {
      if (next === visible) return;
      visible = next;
      bar.classList.toggle('cr-sticky-buy--in', next);
      // aria-hidden as well as opacity: a bar faded out is still in the
      // accessibility tree and would be read out as a second buy button.
      bar.setAttribute('aria-hidden', next ? 'false' : 'true');
    }

    var mq = window.matchMedia(MOBILE);

    if (!('IntersectionObserver' in window)) {
      // Without an observer the honest fallback is to leave the bar off. It is
      // an enhancement; the real button is the product page's actual control.
      return;
    }

    // Two things switch the bar off: the real button being on screen, and the
    // footer being on screen. The second matters because a fixed bar at the
    // very bottom of the page would otherwise sit on top of the legal line in
    // the footer — the one piece of copy on the site that must not be covered.
    var buttonVisible = true;
    var footerVisible = false;

    function sync() {
      show(mq.matches && !buttonVisible && !footerVisible);
    }

    var buttonObserver = new IntersectionObserver(
      function (entries) {
        buttonVisible = entries[0].isIntersecting;
        sync();
      },
      // A little negative margin at the bottom so the bar does not flicker in
      // while the button is still half on screen behind it.
      { rootMargin: '0px 0px -80px 0px' }
    );
    buttonObserver.observe(realButton);

    var footer = document.querySelector('.footer');
    if (footer) {
      var footerObserver = new IntersectionObserver(function (entries) {
        footerVisible = entries[0].isIntersecting;
        sync();
      });
      footerObserver.observe(footer);
    }

    // Rotating a phone into landscape can cross the breakpoint.
    var onChange = function () {
      sync();
    };
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onChange);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(onChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
